import ax from '../axios'
import {API_URL} from "../index";
import { IStoryMetaRequest } from "../../constants";

const STORY_URL = API_URL.EDUCATION_MODULE + '/story-meta'

export type StoryMetaFilterParams = {
  learningAreaId?: number
  unitId?: number
  pypThemeId?: number
}

const getStoryMetaForScreen = (data: IStoryMetaRequest) => {
    return ax.get(`${STORY_URL}/${data.storyId}/${data.languageCode}`)
}

/** GET /story-meta/filter — query params combined as intersection on the server */
const getStoryMetaFilter = (params: StoryMetaFilterParams = {}) => {
  const search = new URLSearchParams()
  if (params.learningAreaId) {
    search.set('learningAreaId', String(params.learningAreaId))
  }
  if (params.unitId) {
    search.set('unitId', String(params.unitId))
  }
  if (params.pypThemeId) {
    search.set('pypThemeId', String(params.pypThemeId))
  }
  const q = search.toString()
  return ax.get(`${STORY_URL}/filter${q ? `?${q}` : ''}`)
}

export {
    getStoryMetaForScreen,
    getStoryMetaFilter,
}
